import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "text-subtitle-2 text-grey py-1"
}
const _hoisted_3 = { class: "pa-3 d-flex flex-column" }
const _hoisted_4 = { class: "text-body-1" }
const _hoisted_5 = { class: "d-inline-flex align-center" }
const _hoisted_6 = { class: "text-body-1 mx-3" }
const _hoisted_7 = {
  key: 1,
  class: "d-sm-flex"
}
const _hoisted_8 = {
  key: 0,
  class: "v-col-sm-10 d-flex flex-wrap justify-sm-start justify-center pt-3 px-0"
}
const _hoisted_9 = { class: "d-inline-flex text-no-wrap justify-space-between v-col ma-0 pa-0" }
const _hoisted_10 = { class: "d-inline-flex text-no-wrap justify-space-between v-col ma-0 pa-0" }
const _hoisted_11 = { class: "v-col-sm-2 pt-2 justify-center align-start" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Далее ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Создание заказа")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "d-inline-flex" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Назад ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Далее ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "d-inline-flex" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Создание резерва ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Продажа на месте ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Оплата онлайн ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Время ожидания оплаты 15 минут!")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_28 = { class: "text-subtitle-1" }
const _hoisted_29 = { class: "text-subtitle-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "text-subtitle-1 align-self-start ml-8" }
const _hoisted_32 = { class: "text-subtitle-1 align-self-start ml-8" }
const _hoisted_33 = { class: "text-subtitle-1 align-self-start ml-8" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Назад")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Создать ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Создание заказа...")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Успешная покупка")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" OK ")
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Что-то пошло не так")
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" OK ")
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = {
  key: 0,
  class: "text-subtitle-1 text-red-darken-1"
}
const _hoisted_60 = { class: "text-subtitle-1" }
const _hoisted_61 = { class: "text-subtitle-2" }
const _hoisted_62 = { class: "text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_ctx.eventData && _ctx.svgHtml)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        class: "mx-md-6 mx-sm-4 mx-xs-0",
        "max-width": "880px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.step) = $event)),
            disabled: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, {
                value: 1,
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    class: "",
                    height: "400px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        border: "",
                        innerHTML: _ctx.svgHtml,
                        class: "pa-0",
                        onTouchstart: _ctx.onClickSvgMap,
                        _touchend: "onClick",
                        onClick: _ctx.onClickSvgMap,
                        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMapPanned = true)),
                        onMouseup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMapPanned = false)),
                        height: "400px",
                        "max-height": "400px",
                        _style: "height: 500px;"
                      }, null, 8, ["innerHTML", "onTouchstart", "onClick"]),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-plus",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoom(true))),
                        class: "mb-1 elevation-5",
                        variant: "flat",
                        style: {"position":"relative","top":"-120px","left":"43%"}
                      }),
                      _hoisted_1,
                      _createVNode(_component_v_btn, {
                        icon: "mdi-minus",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoom(false))),
                        class: "elevation-5",
                        style: {"position":"relative","top":"-120px","left":"43%"}
                      })
                    ]),
                    _: 1
                  }),
                  (0 && !_ctx.selected.seats.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Воспользуйтесь схемой для выбора мест "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.entryTickets, (entry) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: entry.id,
                        class: "d-inline-flex text-no-wrap justify-end align-center"
                      }, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(entry.segmentName), 1),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatMoney(entry.price)), 1),
                          _createVNode(_component_v_spacer),
                          _withDirectives(_createVNode(_component_v_btn, {
                            size: "x-small",
                            variant: "tonal",
                            icon: "mdi-minus",
                            class: "ma-1",
                            onClick: ($event: any) => (_ctx.delEntryToSelected(entry.id))
                          }, null, 8, ["onClick"]), [
                            [_vShow, _ctx.getEntrySelectedCount(entry.segmentId, entry.price)]
                          ]),
                          _withDirectives(_createElementVNode("div", { class: "text-body-1" }, _toDisplayString(_ctx.getEntrySelectedCount(entry.segmentId, entry.price)), 513), [
                            [_vShow, _ctx.getEntrySelectedCount(entry.segmentId, entry.price)]
                          ]),
                          _createVNode(_component_v_btn, {
                            size: "x-small",
                            variant: "tonal",
                            icon: "mdi-plus",
                            class: "ma-1",
                            onClick: ($event: any) => (_ctx.addEntryToSelected(entry))
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_ctx.getTotalSum())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_ctx.eventData.seats)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.seats, (seatId) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: seatId,
                                  width: "138",
                                  "max-width": "138",
                                  "max-height": "110",
                                  class: "bg-grey-lighten-4 mr-2 mb-2",
                                  style: {"cursor":"pointer","user-select":"none"},
                                  onMouseover: ($event: any) => (_ctx.onHoverSelected(seatId)),
                                  onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onLeaveSelected()))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      _createVNode(_component_v_card_subtitle, { class: "text-body-1 pt-3 pb-0 pa-0 v-col-9" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.formatMoney(_ctx.eventData.seats[seatId.toString()].price)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_btn, {
                                        variant: "plain",
                                        class: "ma-0 pa-0 v-col-3",
                                        _density: "compact",
                                        size: "small",
                                        icon: "mdi-close",
                                        onClick: ($event: any) => (_ctx.removeSeatFromSelected(seatId))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _createVNode(_component_v_card_subtitle, { class: "text-body-2 ma-0 pa-0 text-no-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.eventData.seats[seatId.toString()].seatLabel), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_card_subtitle, { class: "pa-0 text-no-wrap text-caption upp" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.eventData.seats[seatId].seatDesc), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onMouseover"]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.entry, (entry, index) => {
                                return (_openBlock(), _createBlock(_component_v_card, {
                                  key: index,
                                  width: "138",
                                  "max-width": "138",
                                  "max-height": "110",
                                  class: "bg-grey-lighten-4 mr-2 mb-2",
                                  style: {"cursor":"pointer","user-select":"none"}
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createVNode(_component_v_card_subtitle, { class: "text-body-1 pt-3 pb-0 pa-0 v-col-9" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.formatMoney(entry.price)), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_btn, {
                                        variant: "plain",
                                        class: "ma-0 pa-0 v-col-3",
                                        _density: "compact",
                                        size: "small",
                                        icon: "mdi-close",
                                        onClick: ($event: any) => (_ctx.delEntryToSelected(entry.id))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _createVNode(_component_v_card_subtitle, { class: "text-body-2 ma-0 pa-0 text-wrap" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(entry.segmentName), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_card_title, { class: "text-xs-h3 text-md-h6 mt-1 pa-0" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatMoney(_ctx.getTotalSum())), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            class: "font-weight-bold ma-3",
                            variant: "flat",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.step=2))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "d-flex flex-column justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
                          ref: "clientForm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                              modelValue: _ctx.orderType,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderType) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  label: "Резерв",
                                  value: "reserve"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Продажа на месте",
                                  value: "offline"
                                }),
                                _createVNode(_component_v_radio, {
                                  disabled: !_ctx.eventData.payAvailable,
                                  label: "Оплата картой",
                                  value: "bankcard"
                                }, null, 8, ["disabled"]),
                                _createVNode(_component_v_radio, {
                                  disabled: !_ctx.eventData.sbpAvailable,
                                  label: "Оплата СБП",
                                  value: "sbp"
                                }, null, 8, ["disabled"]),
                                _createVNode(_component_v_radio, {
                                  disabled: !_ctx.eventData.sbpAvailable,
                                  label: "Оплата SBERPAY",
                                  value: "sberpay"
                                }, null, 8, ["disabled"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_card_text, {
                              disabled: "",
                              label: "Сотрудник",
                              variant: "underlined"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.user ? _ctx.user.email : null), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.client.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.client.name) = $event)),
                              _rules: "nameRules",
                              label: "Имя покупателя",
                              variant: "underlined",
                              _required: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.client.email,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.client.email) = $event)),
                              rules: _ctx.emailRules,
                              label: "E-mail для получения билетов",
                              type: "",
                              variant: "underlined",
                              required: "",
                              "persistent-clear": "",
                              clearable: ""
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.client.tel,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.client.tel) = $event)),
                              _rules: "telRules",
                              prefix: "+7",
                              label: "Телефон покупателя",
                              variant: "underlined",
                              _required: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_textarea, {
                              modelValue: _ctx.orderComment,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.orderComment) = $event)),
                              label: "Комментарий к заказу",
                              variant: "underlined"
                            }, null, 8, ["modelValue"]),
                            _hoisted_16
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_v_container, { class: "d-inline-flex justify-space-between" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.step=1)),
                              variant: "tonal"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_17
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              type: "submit",
                              class: "font-weight-bold",
                              variant: "flat",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSubmitClientForm()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_19
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: 3,
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "d-flex flex-column align-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21,
                        (_ctx.orderType==='reserve')
                          ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            }))
                          : (_ctx.orderType==='offline')
                            ? (_openBlock(), _createBlock(_component_v_card_title, { key: 1 }, {
                                default: _withCtx(() => [
                                  _hoisted_23
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_card_title, { key: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_24,
                                  _createVNode(_component_v_card_subtitle, { class: "text-red" }, {
                                    default: _withCtx(() => [
                                      _hoisted_25
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })),
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.eventData.name), 1),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.eventData.date), 1),
                        _createElementVNode("div", _hoisted_29, "в " + _toDisplayString(_ctx.eventData.venueName), 1),
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.client.name), 1),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.client.tel), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.client.email), 1),
                        _hoisted_34,
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.discount,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.discount) = $event)),
                          type: "number",
                          label: "Скидка",
                          variant: "outlined",
                          onChange: _ctx.discountChange
                        }, null, 8, ["modelValue", "onChange"]),
                        _createVNode(_component_v_expansion_panels, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel_title, { class: "text-body-1 font-weight-bold" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.eventData.ticketNameOf) + ": " + _toDisplayString(_ctx.getTotalCount()) + " ", 1),
                                    _hoisted_35,
                                    _hoisted_36,
                                    _createTextVNode(" Общая сумма: " + _toDisplayString(_ctx.formatMoney(_ctx.getTotalSum())), 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.eventData.seats)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.seats, (seatId) => {
                                        return (_openBlock(), _createBlock(_component_v_expansion_panel_text, {
                                          key: seatId,
                                          class: "text-caption"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.eventData.seats[seatId.toString()].seatLabel) + " " + _toDisplayString(_ctx.eventData.seats[seatId].seatDesc) + ": " + _toDisplayString(_ctx.formatMoney(_ctx.eventData.seats[seatId.toString()].price)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.entry, (entry) => {
                                  return (_openBlock(), _createBlock(_component_v_expansion_panel_text, {
                                    key: entry.id,
                                    class: "text-caption"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(entry.segmentName) + ": " + _toDisplayString(_ctx.formatMoney(entry.price)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_38,
                        _createVNode(_component_v_container, { class: "d-flex justify-space-between" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.step=2)),
                              variant: "tonal"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_39
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              class: "font-weight-bold",
                              variant: "flat",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createOrder()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_40
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: 4,
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_41,
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_sheet, {
                    width: "320px",
                    class: "d-inline-flex flex-column justify-start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_progress_circular, {
                            class: "mt-12",
                            "model-value": "20",
                            size: "100",
                            color: "primary",
                            indeterminate: ""
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: 5,
                disabled: ""
              }),
              _createVNode(_component_v_window_item, {
                value: 6,
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _hoisted_44,
                  _hoisted_45,
                  _createVNode(_component_v_icon, {
                    class: "mb-5",
                    color: "success",
                    icon: "mdi-check-circle",
                    size: "112"
                  }),
                  _hoisted_46,
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_47
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_sheet, {
                    width: "320px",
                    class: "d-inline-flex flex-column justify-start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ваши билеты отправлены на почту " + _toDisplayString(_ctx.client.email), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.windowReload()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_48
                            ]),
                            _: 1
                          }),
                          _hoisted_49,
                          _hoisted_50
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: 7,
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_51,
                  _hoisted_52,
                  _hoisted_53,
                  _createVNode(_component_v_icon, {
                    class: "mb-5",
                    color: "amber-lighten-3",
                    icon: "mdi-close-circle-outline",
                    size: "112"
                  }),
                  _hoisted_54,
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_55
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_sheet, {
                    width: "320px",
                    class: "d-inline-flex flex-column justify-start"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text),
                          _createVNode(_component_v_btn, {
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.windowReload()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_56
                            ]),
                            _: 1
                          }),
                          _hoisted_57,
                          _hoisted_58
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.seatOver && !_ctx.isMapPanned)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                rounded: "",
                border: "",
                ref: "seatTooltip",
                class: "elevation-6 pa-2",
                style: _normalizeStyle([{"position":"absolute"}, _ctx.seatTooltipStyle])
              }, {
                default: _withCtx(() => [
                  (_ctx.getTotalCount() >= _ctx.selectedLimit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, "Не более " + _toDisplayString(_ctx.selectedLimit) + " в один заказ ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formatMoney(_ctx.seatOver.price)), 1),
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.seatOver.seatLabel), 1),
                  _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.seatOver.seatDesc), 1)
                ]),
                _: 1
              }, 8, ["style"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_sheet, {
        key: 1,
        class: "d-flex justify-center align-center",
        height: "500px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            "model-value": "20",
            size: "100",
            color: "primary",
            indeterminate: ""
          })
        ]),
        _: 1
      }))
}